var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
        ]),
        _c("booking-manifest-goods-info", {
          attrs: {
            job: _vm.job,
            "is-editing": _vm.isEditing,
            "lcl-view": true,
            "is-or-not-display-so-no": true,
            "manifest-info": _vm.manifestInfo
          },
          on: { soNoChange: _vm.soNoChangeHandler }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticStyle: { "margin-top": "10px" } },
      [
        _c(
          "el-button",
          {
            attrs: { disabled: _vm.action !== "look", type: "primary" },
            on: { click: _vm.cfmBtnClickHandler }
          },
          [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }